import { forwardRef } from 'react';
import { cn } from '../tokens/cn';
import type { VariantProps } from '../tokens/variants';
import { spinnerVariants } from './spinner.variants';

export interface SpinnerProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'role'>,
    VariantProps<typeof spinnerVariants> {
  label?: string;
}

export const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(
  ({ className, size, tone, label = 'Loading', ...props }, ref) => (
    <span
      ref={ref}
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn(spinnerVariants({ size, tone }), className)}
      {...props}
    >
      <span className="sr-only">{label}</span>
    </span>
  ),
);

Spinner.displayName = 'Spinner';
